import { CancellationReasonEnum, InspectionResult, InspectionStatus, InspectionType } from 'api';
import { translate } from 'i18n';

export const CANCELLATION_REASONS: {
  value: CancellationReasonEnum;
  label: string;
}[] = [
  {
    label: translate('backlog.inspectionMutate.cancellationReasons.dealCancelled', { namespace: 'features' }),
    value: 'DC',
  },
  {
    label: translate('backlog.inspectionMutate.cancellationReasons.missedLoading', { namespace: 'features' }),
    value: 'ML',
  },
  {
    label: translate('backlog.inspectionMutate.cancellationReasons.noCoverage', { namespace: 'features' }),
    value: 'NC',
  },
  {
    label: translate('backlog.inspectionMutate.cancellationReasons.noInspector', { namespace: 'features' }),
    value: 'NI',
  },
  {
    label: translate('backlog.inspectionMutate.cancellationReasons.notNeeded', { namespace: 'features' }),
    value: 'NN',
  },
  { label: translate('backlog.inspectionMutate.cancellationReasons.other', { namespace: 'features' }), value: 'OT' },
  {
    label: translate('backlog.inspectionMutate.cancellationReasons.siteRefused', { namespace: 'features' }),
    value: 'SR',
  },
];
export const INSPECTION_STATUSES: {
  value: InspectionStatus;
  label: string;
}[] = [
  { label: translate('backlog.inspectionMutate.inspectionStatuses.backlog', { namespace: 'features' }), value: 'BL' },
  { label: translate('backlog.inspectionMutate.inspectionStatuses.planning', { namespace: 'features' }), value: 'PL' },
  { label: translate('backlog.inspectionMutate.inspectionStatuses.scheduled', { namespace: 'features' }), value: 'SC' },
  {
    label: translate('backlog.inspectionMutate.inspectionStatuses.booked', { namespace: 'features' }),
    value: 'BOOKED',
  },
  { label: translate('backlog.inspectionMutate.inspectionStatuses.complete', { namespace: 'features' }), value: 'CO' },
  { label: translate('backlog.inspectionMutate.inspectionStatuses.cancelled', { namespace: 'features' }), value: 'CA' },
];
export const INSPECTION_TYPE: {
  value: InspectionType;
  label: string;
}[] = [
  { label: translate('backlog.inspectionMutate.inspectionTypes.standard', { namespace: 'features' }), value: 'STD' },
  { label: translate('backlog.inspectionMutate.inspectionTypes.sirim', { namespace: 'features' }), value: 'SIRIM' },
  { label: translate('backlog.inspectionMutate.inspectionTypes.pern', { namespace: 'features' }), value: 'PERN' },
  {
    label: translate('backlog.inspectionMutate.inspectionTypes.supplier', { namespace: 'features' }),
    value: 'SUPPLIER',
  },
];

export const INSPECTION_RESULTS: {
  value: InspectionResult;
  label: string;
}[] = [
  {
    label: translate('backlog.inspectionMutate.inspectionResults.pending', { namespace: 'features' }),
    value: InspectionResult.PENDING,
  },
  {
    label: translate('backlog.inspectionMutate.inspectionResults.failed', { namespace: 'features' }),
    value: InspectionResult.FAILED,
  },
  {
    label: translate('backlog.inspectionMutate.inspectionResults.passed', { namespace: 'features' }),
    value: InspectionResult.PASSED,
  },
];
